import PropTypes from "prop-types";

import MDBox from "../../../components/MDBox";
import {Card, Grid, Typography} from "@mui/material";

function MenuCard({color = "info", title, subtitle, icon, additionalIcon }) {
    const Icons = icon;
    return (
        <Card pt={1} px={2}>
            <MDBox pt={1} px={2}>
                <Grid container spacing={3} sx={{ width: "100%" }}>
                    <Grid size={3}>
                        {/*<MDBox display="flex" justifyContent="space-between" pt={1} px={2}>*/}
                        <MDBox
                            variant="gradient"
                            bgColor={color}
                            color={color === "light" ? "dark" : "white"}
                            borderRadius="xl"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            width="4rem"
                            height="4rem"
                        >
                            <Icons fontSize="medium" color="inherit"/>
                        </MDBox>
                    </Grid>
                    <Grid size={9}>
                        <MDBox
                            textAlign="right"
                            mt={1.2}
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="center"
                            height="4rem"
                        >
                            <MDBox display="flex" flexDirection="column" alignItems="flex-end">
                                <Typography style={{overflow: "hidden", textOverflow: "ellipsis"}} noWrap={false}
                                            variant="h5" fontWeight="light">
                                    {title}
                                </Typography>
                                { subtitle &&
                                    <Typography variant="caption" fontWeight="regular" sx={{ opacity: 0.7 }}>
                                        {subtitle}
                                    </Typography>
                                }
                            </MDBox>
                            { additionalIcon &&
                                <MDBox
                                    ml={2}
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{
                                        borderLeft: "1px solid",
                                        borderColor: "divider",
                                        paddingLeft: 2,
                                        cursor: "pointer",
                                        height: "100%",
                                        "&:hover": {
                                            opacity: 0.8,
                                        },
                                    }}
                                >
                                    {additionalIcon}
                                </MDBox>
                            }
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
        </Card>
    );
}

// Typechecking props for the ComplexStatisticsCard
MenuCard.propTypes = {
    color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "light",
        "dark",
    ]),
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    icon: PropTypes.object.isRequired,
};

export default MenuCard;
